// utils/getConstants.js
module.exports = function getConstants() {
   const constantsModule = require('../constants');
   return constantsModule.constants || constantsModule.AppConstants || constantsModule.default || constantsModule;
};
